import React, { useContext } from "react";
import { Head } from "./style";
import { ReactComponent as CloseIcon } from "../assets/close_small.svg";
import { CopyAlertContext } from "../../../../context/CopyAlertContext";
import { Overlay } from "../NetworkErrorAlert/style";
import { AlertBox, Message, MessageContainer } from "../SuccessAlert/style";

const AlertComponent = () => {
  const { onClose } = useContext(CopyAlertContext);
  const onClick = () => {
    onClose();
  };
  return (
    <Overlay>
      <AlertBox>
        <MessageContainer>
          <Head>Copied</Head>
          <Message>Key has been copied to your clipboard</Message>
        </MessageContainer>
        
        <button onClick={onClick}>
          <CloseIcon />
        </button>
      </AlertBox>
    </Overlay>
  );
};

const CopyAlertAlert = () => {
  return <AlertComponent />;
};

export default CopyAlertAlert;
